import _ from 'lodash-es';

// Move the dropdown menu arrow to always be centered with the text of the link the user hovered over
let cached_stylesheet = null;
const updated_arrows = {};
const positionDropdownArrows = ($this, $sublist) => {
  const id = $sublist.attr('id');

  if (!updated_arrows[id]) {
    updated_arrows[id] = true;
    const left = $this.find('a').width() / 2;
    // jQuery can't access :before since it's not part of the DOM.
    // But...we can just add a rule to the stylesheet itself.
    if (!cached_stylesheet) {
      _.each(document.styleSheets, (stylesheet) => {      
        if (stylesheet.ownerNode.getAttribute('id') === 'navDropdowns') {
          cached_stylesheet = stylesheet;
        }
      });
    }

    cached_stylesheet.addRule(`#${id}:before`, `left: ${left}px;`);
  }
};

export default function() {

   // Set max-height on dropdown hover to trigger animation and open dropdown
  $(document).on('mouseenter', '[data-nav-dropdown-hover]', (e) => {
    const $this = $(e.currentTarget);
    const $dropdown = $this.find('[data-nav-dropdown]');
    const $sublist = $dropdown.find('[data-nav-sublist]');
    
    positionDropdownArrows($this, $sublist);

    // $sublist[0].offsetTop gets the triangle height
    const max_height = $sublist.outerHeight() + $sublist[0].offsetTop;
    $dropdown.css('max-height', max_height);
  });

  // Unset max-height to close dropdown
  $(document).on('mouseleave', '[data-nav-dropdown-hover]', (e) => {
    const $dropdown = $(e.currentTarget).find('[data-nav-dropdown]');
    $dropdown.css('max-height', 0);
  });
}